<template>
    <div class="mb-5">
        <strong class="d-block" v-html="offer.info.modelName" />
        <strong class="d-block">{{ $t('date') }}: {{ $filters.dateFormat(searchRequest.pickUpDateTime) }}</strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_CARS_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class CarConditionsModalInfo extends Vue {
        searchRequest = {}
        offer = {info: {}}

        mounted() {
            EventBus.$on(SHOW_CARS_CONDITIONS_INFO, this.showInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_CARS_CONDITIONS_INFO, this.showInfo)
        }

        showInfo({searchRequest, product: offer}) {
            this.searchRequest = searchRequest
            this.offer = offer
        }
    }

    export default CarConditionsModalInfo
</script>
